import { merge } from 'lodash'
import Block from './block'
import Imageable from '@/models/imageable'
import Linkable from '@/models/linkable'

class ProductBlock extends Block {

  constructor(block) {
    super(block)
    this.type = 'product'
    this.alias = `商品 - ${this.uid}`
    this.template = ''
    this.theme = ''
    this.title = ''
    this.title_visible = false
    this.items = []
    this.mobile = {
      header: {
        background_image: new Imageable(),
        background_color: '',
        color: ''
      },
      body: {
        background_image: new Imageable(),
        background_color: ''
      },
      banner: {
        image: new Imageable(),
        linkable: new Linkable()
      }
    }
    this.desktop = {
      header: {
        background_image: new Imageable(),
        background_color: '',
        color: ''
      },
      body: {
        background_image: new Imageable(),
        background_color: ''
      },
      banner: {
        image: new Imageable(),
        linkable: new Linkable()
      }
    }

    if (block) {
      merge(this, block)
    }
  }

  get anyBanner() {
    return this.template === 'PD_1B6S_A' || this.template === 'PD_1B6S_B' || this.template === 'PD_1B3S_A'
  }

}

export default ProductBlock



// WEBPACK FOOTER //
// ./src/models/blocks/product.js